// Module
var code = "<div class=\"brs-projects-statics-regionschart\">\n\n</div>\n\n<div class=\"brs-projects-statics-regionscountrieschart\">\n\n</div>\n";
// Exports
export default code;